
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'AlertPromoCodeError',

  props: {
    promocodeError: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  }
})
